import React, { Component } from "react";

// import Loader from "../../prefabs/loader/view";





class Button extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }



  // ===============================================================================================
  onClick(e) {
    e.preventDefault();

    if (this.props.handleClick) {
      this.props.handleClick();
    }
  }



  // ===============================================================================================
  render() {
    return (
      <button
        tabIndex="-1"
        className={"maccas-btn maccas-btn--inverted" + (( this.props.className) ? " " + this.props.className : "") + ((!this.props.canSubmit) ? " maccas-btn--disabled"    : "")}
        disabled={this.props.disabled}
        onClick={this.onClick}
      >
        <div>
          {this.props.label}
        </div>

      </button>
    );
  }

}



export default Button
